import globals from './globals.json'

const measures = globals.measures

export default measures
